import { useGlobalAction } from "@gadgetinc/react";
import { useEffect, useState, useRef } from "react";
import { api } from "../../../../api";

export function useCompanyUsers() {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const hasInitialized = useRef(false);

  const [{ data: companyUsers, fetching }, getAllUsers] = useGlobalAction(
    api.getAllUsers,
  );

  useEffect(() => {
    if (!hasInitialized.current && !fetching) {
      hasInitialized.current = true;
      getAllUsers();
    }
  }, [getAllUsers, fetching]);

  useEffect(() => {
    if (companyUsers && !fetching) {
      const transformedUsers = companyUsers
        ?.map(({ id, email, firstName, lastName, phone }) => ({
          id,
          email,
          firstName,
          lastName,
          phone,
          modified: false,
        }))
        ?.filter(
          (u) =>
            !u.email.includes("@getsimio.com") &&
            !u.email.includes("@alcmeon.com"),
        );

      setUsers(transformedUsers || []);
    }
  }, [companyUsers, fetching]);

  const updateUser = (email, field, value) => {
    setUsers((prevUsers) =>
      prevUsers.map((user) =>
        user.email === email
          ? {
              ...user,
              [field]: value,
              modified: true,
            }
          : user,
      ),
    );
  };

  const saveUsersSettings = async () => {
    setIsLoading(true);
    try {
      const userData = users
        .filter((user) => user.modified)
        .map(({ id, firstName, lastName }) => ({ id, firstName, lastName }));

      if (userData.length > 0) {
        await api.updateUsersNames({ userData });

        setUsers((prevUsers) =>
          prevUsers.map((user) => ({ ...user, modified: false })),
        );
      }
    } catch (error) {
      console.error("Unable to update the users", error);
    } finally {
      setIsLoading(false);
    }
  };

  const refetch = () => {
    hasInitialized.current = false;
    getAllUsers();
  };

  return {
    users,
    isLoading,
    saveUsersSettings,
    updateUser,
    refetch,
    isFetching: fetching,
  };
}
